const HEADER = "RO-eID";

const NAVBAR_DATA = [
  { id: 1, url: "/", label: "Home" },
  { id: 2, url: "#services", label: "Servicii" },
  { id: 3, url: "#about-us", label: "De ce eID?" },
  { id: 4, url: "#testimonials", label: "Echipa de dezvoltare" },
  { id: 5, url: "#footer", label: "Contacte" }
];
const BANNER_DATA = {
  HEADING: "Autentificare cetăţean cu e-ID",
  DECRIPTION:
    "Interacţionaţi cu toate serviciile primăriei Amara prin portalul de servicii electronice, în deplină siguranţă, cu autentificare electronică.",
  TUTORIAL_URL:
    "https://youtu.be/Wx36IvgEJOo",
  WATCH_TUTORIAL: "Demonstraţie video"
};
const SERVICE_DATA = {
  HEADING: "Avantajele e-ID",
  ALL_SERVICES: "",
  SERVICE_LIST: [
    {
      LABEL: "Foloseşti telefonul tău",
      DESCRIPTION:
        "Instalezi aplicaţia de autentificare pe telefonul tău, Android sau iOS. După ce un operator al primăriei te autentifică vizual, vei folosi telefonul ca o cheie de acces în poralul de servicii ale Primăriei.",
      URL: "images/service1.png"
    },
    {
      LABEL: "Nu te mai deplasezi",
      DESCRIPTION:
        "Nu mai stai la coadă pentru a depunde documente la primărie. Accesezi de acasă portalul de servicii electronice şi trimiţi toate documentele. Vei fi apoi autentificat prin telefon pentru a 'semna' documentele.",
      URL: "images/service2.png"
    },
    {
      LABEL: "Multiple avantaje",
      DESCRIPTION:
        "Eviţi amenzile pentru nedepunerea documentelor, eviţi aglomeraţia şi riscul de îmbolnăvire, ajuţi comunitatea să depăşească momentul pandemiei.",
      URL: "images/service3.png"
    }
  ]
};

const ABOUT_DATA = {
  HEADING: "De ce să alegi e-ID?",
  TITLE: "Ce ne deosebeşte de ceilalţi?",
  IMAGE_URL: "images/network.png",
  WHY_CHOOSE_US_LIST: [
    "În primul rând că e gratuit. COMPLET!",
    "Siguranţă în autentificarea ta în portal.",
    "Nu mai trebuie să ţii minte nume de utilizator şi parolă.",
    "Faci totul de acasă.",
    "Vei putea folosi e-ID în viitor şi pentru alte servicii electronice.",
    "Primeşti pe telefon informări de la Primărie despre rezolvarea cererilor tale.",
    "Și nu în ultimul rând că este GRATUIT! Dar parcă am mai zis asta, nu?"
  ]
};
const TESTIMONIAL_DATA = {
  HEADING: "Echipa de dezvoltare",
  TESTIMONIAL_LIST: [
    {
      DESCRIPTION:
        "Din interacţiunea de peste 25 de ani în lucrul cu diverse instituţii din administraţia publică, am căpătat o experienţă vastă, ştim în amănunţime despre necesităţile aparatului de lucru, despre legislaţie şi livrăm soluţiile cele mai potrivite.",
      IMAGE_URL: "images/liviu.jpg",
      NAME: "Liviu Ilie",
      DESIGNATION: "CEO DataSystems"
    },
    {
      DESCRIPTION:
        "Programele destinate publicului trebuie să fie uşor de folosit, pe înţelesul cetăţeanului. Nu scriem software cu zeci de ecrane şi sute de butoane pentru a epata clientul şi a mări valoarea de pe factură, scriem programe pentru a rezolva PROBLEME!",
      IMAGE_URL: "images/user2.jpg",
      NAME: "Constantin Teodorecu",
      DESIGNATION: "predicator Linux"
    }
  ]
};

const SOCIAL_DATA = {
  HEADING: "Ne găsiţi şi pe internet",
  IMAGES_LIST: [
    "images/facebook-icon.png",
    "images/instagram-icon.png",
    "images/whatsapp-icon.png",
    "images/twitter-icon.png",
    "images/linkedin-icon.png",
    "images/snapchat-icon.png"
  ]
};

const FOOTER_DATA = {
  DESCRIPTION:
    "Eşti o instituţie publică ce oferă servicii electronice către cetăţeni? Sigur avem o soluţie pentru a securiza accesul la portalul tău de servicii şi pentru a autentifica cetăţeanul cu un mare grad de siguranţă!",
  CONTACT_DETAILS: {
    HEADING: "Contactaţi-ne",
    ADDRESS: "str. Dumbrava Roşie, nr. 1-4, Slobozia",
    MOBILE: "+40 731 749 719",
    EMAIL: "office@dsn.ro"
  },
  SUBSCRIBE_NEWSLETTER: "Vrei să primeşti informări lunare?",
  SUBSCRIBE: "Abonează-te"
};

const MOCK_DATA = {
  HEADER,
  NAVBAR_DATA,
  BANNER_DATA,
  SERVICE_DATA,
  ABOUT_DATA,
  TESTIMONIAL_DATA,
  SOCIAL_DATA,
  FOOTER_DATA
};
export default MOCK_DATA;
